<template lang="pug">
.generate-inventories
  v-card
    v-toolbar(color="primary", dark, flat)
      v-toolbar-title Generador de Inventarios
    v-card-text
      ValidationObserver(ref="observer", v-slot="{ validate, reset }")
        v-form
          v-row
            v-col(cols="12", sm="12", md="6")
              ValidationProvider(
                v-slot="{ errors }",
                name="Número de inventarios"
                rules="required|min:0|numeric"
              )
                v-text-field(
                  v-model="inventory_gen.total"
                  label='Número de inventarios',
                  type='number',
                  :error-messages="errors",
                  required
                )
            v-col(cols="12", sm="12", md="6")
              ValidationProvider(
                v-slot="{ errors }",
                rules="required",
                name="Tipo Inventario"
              )
                v-autocomplete(
                  v-model="inventory_gen.type"
                  label="Tipo Inventario",
                  type="text",
                  :items="choices.inventory_type",
                  item-text="name",
                  item-value="id",
                  :error-messages="errors",
                  clearable,
                  required
                )
            v-col(cols="12", sm="12", md="6")
              ValidationProvider(
                v-slot="{ errors }",
                rules="required",
                name="Stock"
              )
                v-autocomplete(
                  v-model="inventory_gen.stock"
                  label="Stock",
                  type="text",
                  :items="stocks",
                  item-text="brand",
                  item-value="id",
                  :error-messages="errors",
                  clearable,
                  required
                )
            v-col(cols="12", sm="12", md="6")
              ValidationProvider(
                v-slot="{ errors }",
                rules="required",
                name="Veterinario"
              )
                v-autocomplete(
                  v-model="inventory_gen.vet"
                  label="Veterinario",
                  type="text",
                  :items="users",
                  item-text="email",
                  item-value="email",
                  :error-messages="errors",
                  clearable,
                  required
                )
    v-card-actions
      v-spacer
      v-btn(
        color="secondary",
        @click="generate",
        :loading="loading",
        :disabled="loading"
      ) Generar
</template>

<script>
import inventoryAPI from "@/api/inventories";
import { mapState, mapGetters } from "vuex";
import { required, min, numeric } from "vee-validate/dist/rules";
import {
  extend,
  ValidationObserver,
  ValidationProvider,
  setInteractionMode
} from "vee-validate";

setInteractionMode("eager");

extend("required", {
  ...required,
  message: "{_field_} no puede ser vacío"
});

extend("min", {
  ...min,
  message: "{_field_} no puede ser menor que {length} caracteres"
});

extend("numeric", {
  ...numeric,
  message: "{_field_} admite números"
});

export default {
  name: "GenerateInventory",
  async created() {
    await this.$store.dispatch(
      "stock/getStockWithoutPagination",
      this.auth_token
    );
    await this.$store.dispatch("users/getUserWithoutPagination", {
      token: this.auth_token,
      vet: true,
      owner: false
    });
  },
  components: {
    ValidationProvider,
    ValidationObserver
  },
  computed: {
    ...mapGetters({
      choices: "selectChoices"
    }),
    ...mapState({
      stocks: state => state.stock.StockWithoutPagination,
      users: state => state.users.vets_without_pagination,
      auth_token: state => state.auth.auth_token
    })
  },
  data() {
    return {
      loading: false,
      inventory_gen: {
        type: null,
        stock: null,
        total: null,
        vet: null
      }
    };
  },
  methods: {
    async generate() {
      if (await this.$refs.observer.validate()) {
        this.loading = true;
        const response = await inventoryAPI.generateInventory(
          this.inventory_gen,
          this.auth_token
        );
        this.loading = false;

        this.$swal({
          icon: response.status ? "success" : "warning",
          title: response.status ? response.data.message : response.data
        });

        if (response.status) {
          await this.$store.dispatch("inventories/getInventories", {
            page: 1,
            email: null,
            assign: null,
            pagination: true,
            code: code ?? null,
            token: this.auth_token
          });
        }
      }
    }
  }
};
</script>
